/* ============================================================
   ROZHEVA SITKA — GIFT BOX 2026 — Core logic
   ============================================================
   Зависит от: window.QF_MESH_GIFT_CONFIG (snippets/mesh-gift-config.liquid)
   Зависит от: mesh-gift.css

   Механика (как Kyiv Day / Easter):
     • скидка = скрытый товар-триггер в корзине + Shopify Automatic Discount
     • бретелі = скрытый товар-подарок 0₴ с выбором вида
     • промокоды пользователю НЕ показываются
     • pending: если корзина пуста — подарок «резервируется» и добавляется
       при появлении первого реального товара
     • cart guard: чекаут блокируется, если в корзине только подарки
     • cart harden: у строк-подарков убрана ссылка и заблокировано количество
   ============================================================ */

(function () {
  'use strict';

  var CFG = window.QF_MESH_GIFT_CONFIG;
  if (!CFG) {
    console.warn('[MeshGift] QF_MESH_GIFT_CONFIG not found. Disabled.');
    return;
  }
  if (CFG.enabled === false) return;

  var STORAGE_KEY = 'qfMeshGift2026';
  var PROP_GIFT = '_qf_gift';       // подарок (бретелі)
  var PROP_TRIGGER = '_qf_trigger'; // триггер скидки
  var PROP_PRIZE = '_qf_prize';     // id приза (аналитика)

  var DEBUG = !!CFG.debug;
  // Прячем конфиг из window, чтобы не достали variant_id/логику через консоль.
  if (!DEBUG) {
    try { delete window.QF_MESH_GIFT_CONFIG; } catch (e) { window.QF_MESH_GIFT_CONFIG = undefined; }
  }

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ─── Storage ────────────────────────────────────────────────
  function defaultProgress() {
    return {
      opened: false,
      prizeId: null,
      strapsVariantKey: null,
      claimed: false,
      autoShown: false,      // авто-показ попапа уже был (чтобы не навязываться)
      pendingTrigger: null, // { variantId, prizeId }
      pendingGift: null      // { variantId, prizeId }
    };
  }
  function loadProgress() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultProgress();
      return Object.assign(defaultProgress(), JSON.parse(raw));
    } catch (e) { return defaultProgress(); }
  }
  function saveProgress(p) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(p)); } catch (e) {}
  }
  var progress = loadProgress();

  // ─── Campaign window ────────────────────────────────────────
  var now = Date.now();
  var campaignStart = new Date(CFG.campaignStart).getTime();
  var campaignEnd   = new Date(CFG.campaignEnd).getTime();
  var isCampaignActive  = now >= campaignStart && now <= campaignEnd;
  var isCampaignExpired = now > campaignEnd;

  // ─── Cart API ───────────────────────────────────────────────
  var qfInternal = 0;   // счётчик наших собственных запросов к корзине (чтобы не реагировать на них)
  function dec() { if (qfInternal > 0) qfInternal--; }

  function cartGet() {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [], item_count: 0 }; });
  }
  function cartAdd(variantId, properties) {
    qfInternal++;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties || {} })
    }).then(function (r) { dec(); return r.json(); }, function (e) { dec(); throw e; });
  }
  function cartChangeQty(lineKey, qty) {
    qfInternal++;
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(function (r) { dec(); return r.json(); }, function (e) { dec(); throw e; });
  }

  // Правила для подарков в корзине:
  //  • количество каждого подарка = 1 (нельзя размножить);
  //  • подарок-бретелі только ОДИН (лишние строки-подарки удаляем, оставляем одну).
  function enforceGiftQuantities() {
    return cartGet().then(function (cart) {
      var items = cart.items || [];
      var giftLines = items.filter(function (it) { return it.properties && it.properties[PROP_GIFT]; });
      var changes = [];
      // дубликаты подарков — оставляем первый, остальные удаляем
      giftLines.slice(1).forEach(function (it) { changes.push({ key: it.key, qty: 0 }); });
      // количество > 1 у любого нашего extra — вернуть к 1 (для оставшихся)
      items.forEach(function (it) {
        if (!isQfExtra(it)) return;
        var willRemove = changes.some(function (c) { return c.key === it.key && c.qty === 0; });
        if (!willRemove && it.quantity > 1) changes.push({ key: it.key, qty: 1 });
      });
      if (!changes.length) return false;
      var chain = Promise.resolve();
      changes.forEach(function (c) { chain = chain.then(function () { return cartChangeQty(c.key, c.qty); }); });
      return chain.then(function () { refreshCartUI(); return true; });
    });
  }
  // Дать увидеть уведомление в попапе, затем перезагрузить страницу (подарок появится в корзине)
  var reloadScheduled = false;
  function reloadSoon(delay) {
    if (reloadScheduled) return;
    reloadScheduled = true;
    setTimeout(function () { try { window.location.reload(); } catch (e) {} }, delay || 1300);
  }

  function refreshCartUI() {
    cartGet().then(function (cart) {
      var count = cart.item_count || 0;
      document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]').forEach(function (b) {
        b.textContent = count;
      });
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } })); } catch (e) {}
    });
  }

  // ─── Cart helpers ───────────────────────────────────────────
  function isQfExtra(item) {
    return item.properties && (item.properties[PROP_GIFT] || item.properties[PROP_TRIGGER]);
  }
  function hasRealItems(cart) {
    return (cart.items || []).some(function (it) { return !isQfExtra(it) && it.price > 0; });
  }
  function hasVariantInCart(cart, variantId) {
    return (cart.items || []).some(function (it) { return it.variant_id === variantId; });
  }

  // ─── Expired cleanup ────────────────────────────────────────
  function cleanupExpired() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    cartGet().then(function (cart) {
      var keys = (cart.items || []).filter(isQfExtra).map(function (it) { return it.key; });
      var chain = Promise.resolve();
      keys.forEach(function (k) { chain = chain.then(function () { return cartChangeQty(k, 0); }); });
      chain.then(refreshCartUI);
    });
  }

  // ─── Gift lookup ────────────────────────────────────────────
  function giftById(id) {
    return CFG.gifts.filter(function (g) { return g.id === id; })[0] || null;
  }
  function allExtraVariantIds() {
    var ids = [];
    CFG.gifts.forEach(function (g) {
      if (g.type === 'trigger' && g.triggerVariantId) ids.push(g.triggerVariantId);
      if (g.type === 'gift_color' && g.variants) {
        g.variants.forEach(function (v) { if (v.id) ids.push(v.id); });
      }
    });
    return ids;
  }

  // ─── Weighted random ────────────────────────────────────────
  function pickGift() {
    var total = CFG.gifts.reduce(function (s, g) { return s + (g.weight || 0); }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < CFG.gifts.length; i++) {
      r -= (CFG.gifts[i].weight || 0);
      if (r <= 0) return CFG.gifts[i];
    }
    return CFG.gifts[CFG.gifts.length - 1];
  }

  // ─── DOM helpers ────────────────────────────────────────────
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function lockScroll()   { document.documentElement.classList.add('qf-gift-noscroll'); document.body.classList.add('qf-gift-noscroll'); }
  function unlockScroll() { document.documentElement.classList.remove('qf-gift-noscroll'); document.body.classList.remove('qf-gift-noscroll'); }

  // ─── Overlay / modal shell ──────────────────────────────────
  var escHandler = null;
  function closeOverlay() {
    var o = document.getElementById('qf-gift-overlay');
    if (o) {
      o.classList.remove('qf-gift-overlay--in');
      setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 350);
    }
    unlockScroll();
    if (escHandler) { document.removeEventListener('keydown', escHandler); escHandler = null; }
  }

  // opts: { dismissible, build(modal) }
  function openOverlay(opts) {
    // синхронно убираем предыдущий оверлей (без анимации), чтобы не было двух #qf-gift-overlay
    var prev = document.getElementById('qf-gift-overlay');
    if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
    if (escHandler) { document.removeEventListener('keydown', escHandler); escHandler = null; }

    var overlay = el('div', 'qf-gift-overlay qf-gift-root');
    overlay.id = 'qf-gift-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var modal = el('div', 'qf-gift-modal');

    // логотип
    if (CFG.assets && CFG.assets.logo) {
      var logo = el('img', 'qf-gift-logo');
      logo.src = CFG.assets.logo; logo.alt = 'Queenfluence';
      modal.appendChild(logo);
    }

    // крестик
    var dismissible = opts.dismissible !== false;
    if (dismissible) {
      var close = el('button', 'qf-gift-close', '×');
      close.type = 'button';
      close.setAttribute('aria-label', CFG.texts.closeAria || 'Закрити');
      close.onclick = closeOverlay;
      modal.appendChild(close);
    }

    opts.build(modal);

    overlay.appendChild(modal);

    // клик по затемнению
    if (dismissible) {
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    }

    document.body.appendChild(overlay);
    lockScroll();
    requestAnimationFrame(function () { overlay.classList.add('qf-gift-overlay--in'); });

    // Escape
    if (dismissible) {
      escHandler = function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeOverlay(); };
      document.addEventListener('keydown', escHandler);
    }
    return modal;
  }

  // ─── Экран 1: intro + коробка ───────────────────────────────
  function showIntro() {
    var t = CFG.texts.intro;
    openOverlay({
      dismissible: true,
      build: function (modal) {
        modal.appendChild(el('h2', 'qf-gift-title', t.title));
        modal.appendChild(el('p', 'qf-gift-body', t.body));
        if (t.extra) modal.appendChild(el('p', 'qf-gift-extra', t.extra));

        var stage = buildStage();
        modal.appendChild(stage.node);

        if (t.callout) modal.appendChild(el('p', 'qf-gift-callout', t.callout));

        var btn = el('button', 'qf-gift-btn', t.button);
        btn.type = 'button';
        modal.appendChild(btn);

        var triggered = false;
        function go() {
          if (triggered) return;
          triggered = true;
          btn.disabled = true;
          runOpenSequence(stage, modal);
        }
        stage.clickTarget.addEventListener('click', go);
        btn.addEventListener('click', go);
      }
    });
  }

  // ─── Сцена коробки (слои) ───────────────────────────────────
  function buildStage() {
    var A = CFG.assets || {};
    var stage = el('div', 'qf-gift-stage');

    // свечение
    if (A.glow) { var g = el('img', 'qf-gift-layer qf-gift-layer--glow'); g.src = A.glow; g.alt = ''; stage.appendChild(g); }
    else stage.appendChild(el('div', 'qf-gift-glowfallback'));

    // сетки (под коробкой)
    if (A.meshBoth) { var mb = el('img', 'qf-gift-layer qf-gift-layer--mesh-both'); mb.src = A.meshBoth; mb.alt=''; stage.appendChild(mb); }
    else {
      if (A.meshPink) { var mp = el('img', 'qf-gift-layer qf-gift-layer--mesh-pink'); mp.src = A.meshPink; mp.alt=''; stage.appendChild(mp); }
      if (A.meshBlue) { var mbl = el('img', 'qf-gift-layer qf-gift-layer--mesh-blue'); mbl.src = A.meshBlue; mbl.alt=''; stage.appendChild(mbl); }
    }

    // частицы: картинка Sparkles или CSS-фолбэк
    if (A.particles) {
      var sp = el('img', 'qf-gift-layer qf-gift-layer--sparkles');
      sp.src = A.particles; sp.alt = '';
      stage.appendChild(sp);
    } else {
      var particles = el('div', 'qf-gift-particles');
      for (var i = 0; i < 14; i++) {
        var p = el('span', 'qf-gift-particle');
        var ang = (i / 14) * Math.PI * 2;
        var dist = 70 + (i % 4) * 14;
        p.style.setProperty('--qf-dx', Math.cos(ang) * dist + 'px');
        p.style.setProperty('--qf-dy', Math.sin(ang) * dist + 'px');
        p.style.animationDelay = (0.1 + (i % 5) * 0.05) + 's';
        if (i % 2) p.style.background = 'var(--qf-blue)';
        particles.appendChild(p);
      }
      stage.appendChild(particles);
    }

    // открытая коробка
    if (A.boxOpen) { var bo = el('img', 'qf-gift-layer qf-gift-layer--box-open'); bo.src = A.boxOpen; bo.alt=''; stage.appendChild(bo); }

    // закрытая коробка / фолбэк
    var clickTarget;
    if (A.boxClosed) {
      var bc = el('img', 'qf-gift-layer qf-gift-layer--box-closed');
      bc.src = A.boxClosed; bc.alt = CFG.texts.boxAria || 'Подарунок';
      bc.setAttribute('role', 'button');
      bc.setAttribute('tabindex', '0');
      stage.appendChild(bc);
      clickTarget = bc;
    } else {
      var fb = el('div', 'qf-gift-boxfallback', '🎁');
      fb.setAttribute('role', 'button');
      fb.setAttribute('tabindex', '0');
      fb.setAttribute('aria-label', CFG.texts.boxAria || 'Відкрити коробку');
      stage.appendChild(fb);
      clickTarget = fb;
    }

    return { node: stage, el: stage, clickTarget: clickTarget };
  }

  // ─── Анимация открытия → reveal ─────────────────────────────
  function runOpenSequence(stage, modal) {
    // выбираем приз (если ещё не открыт)
    var gift;
    if (progress.opened && progress.prizeId) {
      gift = giftById(progress.prizeId);
    } else {
      gift = pickGift();
      progress.opened = true;
      progress.prizeId = gift.id;
      saveProgress(progress);
    }

    if (REDUCED) {
      showResult(gift, modal);
      return;
    }

    // фаза 1: покачивание закрытой коробки (антисипация)
    stage.el.classList.add('qf-gift-stage--opening');
    // фаза 2: коробка открывается, свечение, сетки, частицы
    setTimeout(function () {
      stage.el.classList.remove('qf-gift-stage--opening');
      stage.el.classList.add('qf-gift-stage--opened');
    }, 1100);
    // фаза 3: карточка результата — даём налюбоваться раскрытием
    setTimeout(function () { showResult(gift, modal); }, 3200);
  }

  // ─── Экран результата ───────────────────────────────────────
  function showResult(gift, modal) {
    // перерисовываем содержимое модалки «на месте»
    // (сохраняем логотип и крестик, если были — проще пересоздать overlay)
    var t = CFG.texts.result;
    openOverlay({
      dismissible: true,
      build: function (m) {
        m.appendChild(el('h2', 'qf-gift-title', t.title));
        m.appendChild(el('div', 'qf-gift-prize', tmpl(t.prizeTemplate, { title: gift.title })));

        if (gift.type === 'gift_color') {
          buildStrapsResult(gift, m, t);
        } else {
          buildDiscountResult(gift, m, t);
        }

        m.appendChild(el('p', 'qf-gift-conditions', t.conditions));
      }
    });
  }

  // Скидка — код гостю НЕ показывается. Выпавший промокод применяется тихо.
  //   • если задан gift.code       → /discount/CODE (Shopify сам применит на чекауте)
  //   • если задан triggerVariantId → старый способ через скрытый товар-триггер
  function buildDiscountResult(gift, m, t) {
    m.appendChild(el('p', 'qf-gift-status', t.discountActivated));
    m.appendChild(el('p', 'qf-gift-hint', t.discountHint));

    var btn = el('a', 'qf-gift-btn', t.button);
    btn.href = CFG.collectionUrl || '/collections/all';
    m.appendChild(btn);

    if (progress.claimed) return; // применяем только один раз
    if (gift.triggerVariantId) {
      activateTrigger(gift);            // через товар-триггер + Automatic Discount
    } else if (gift.code) {
      applyDiscountCode(gift.code);     // тихо применяем промокод
      markClaimed();
    }
  }

  // Тихое применение промокода через Shopify discount-ссылку.
  // /discount/CODE проставляет скидку в сессии; при чекауте применяется сама.
  // Гость кода не видит — только результат «Скидку вже активовано».
  function applyDiscountCode(code) {
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=/';
    // 1) fetch следует за редиректом и ставит скидку невидимо
    fetch(url, { credentials: 'same-origin' }).catch(function () {
      // 2) фолбэк — скрытый iframe
      try {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        f.src = url;
        document.body.appendChild(f);
        setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 8000);
      } catch (e) {}
    });
  }

  // Бретелі: двухшаговый выбор — выделить фасон, затем «Обрати» подтверждает.
  // Свотчи и «Обрати» остаются активными всегда — можно поменять фасон или
  // добавить подарок заново, если гость удалил его из корзины.
  function buildStrapsResult(gift, m, t) {
    var selectedKey = progress.strapsVariantKey || null;   // текущее выделение
    var alreadyGot = !!progress.strapsVariantKey;          // хоть раз подтверждал

    // тексты берём из подарка, иначе общие
    var pickTitle = gift.pickTitle || t.strapsPickTitle;
    var pickHint  = gift.pickHint  || t.strapsPickHint;
    var addedText = gift.addedText || t.strapsAdded;

    var status = el('p', 'qf-gift-status', alreadyGot ? addedText : pickTitle);
    m.appendChild(status);

    var hint = el('p', 'qf-gift-hint', pickHint);
    m.appendChild(hint);

    var wrap = el('div', 'qf-gift-swatches');
    if ((gift.variants || []).some(function (v) { return v.image; })) wrap.classList.add('qf-gift-swatches--img');
    if ((gift.variants || []).length > 6) wrap.classList.add('qf-gift-swatches--many');
    (gift.variants || []).forEach(function (v) {
      var sw = el('button', 'qf-gift-swatch');
      sw.type = 'button';
      sw.setAttribute('aria-label', v.label);
      if (v.image) {
        var thumb = el('span', 'qf-gift-swatch__img');
        var img = el('img'); img.src = v.image; img.alt = v.label; img.loading = 'lazy';
        thumb.appendChild(img);
        sw.appendChild(thumb);
      } else {
        var dot = el('span', 'qf-gift-swatch__dot');
        dot.style.background = v.hex || '#ccc';
        sw.appendChild(dot);
      }
      sw.appendChild(el('span', 'qf-gift-swatch__label', v.label));
      if (selectedKey === v.key) sw.classList.add('qf-gift-swatch--selected');
      sw.addEventListener('click', function () {
        selectedKey = v.key;
        wrap.querySelectorAll('.qf-gift-swatch').forEach(function (s) { s.classList.remove('qf-gift-swatch--selected'); });
        sw.classList.add('qf-gift-swatch--selected');
        confirmBtn.disabled = false;
      });
      wrap.appendChild(sw);
    });
    m.appendChild(wrap);

    // «Обрати» — подтвердить/повторно применить выбор.
    // Активна, если фасон выделен ИЛИ уже был выбран раньше (чтобы можно было
    // повторно додати подарунок після видалення).
    var confirmBtn = el('button', 'qf-gift-btn', t.strapsConfirm || 'Обрати');
    confirmBtn.type = 'button';
    confirmBtn.disabled = !(selectedKey || alreadyGot);
    confirmBtn.addEventListener('click', function () {
      var key = selectedKey || progress.strapsVariantKey ||
                ((gift.variants || [])[0] && gift.variants[0].key);
      if (!key) return;
      var variant = (gift.variants || []).filter(function (x) { return x.key === key; })[0];
      if (!variant) return;
      selectedKey = key;
      // подсветим выбранный, если ещё не подсвечен
      wrap.querySelectorAll('.qf-gift-swatch').forEach(function (s, i) {
        s.classList.toggle('qf-gift-swatch--selected', (gift.variants[i] && gift.variants[i].key) === key);
      });
      // уведомляем: подарок добавлен (страница обновится сама)
      status.textContent = addedText;
      confirmBtn.textContent = addedText;
      confirmBtn.disabled = true;
      chooseStraps(gift, variant);   // добавит в корзину (дедуп → ровно один) + reloadSoon
    });
    m.appendChild(confirmBtn);

    // «Перейти до новинок» — отдельной ссылкой ниже
    var navBtn = el('a', 'qf-gift-btn qf-gift-btn--ghost', t.button);
    navBtn.href = CFG.collectionUrl || '/collections/all';
    m.appendChild(navBtn);
  }

  function chooseStraps(gift, variant) {
    progress.strapsVariantKey = variant.key;
    saveProgress(progress);
    if (!variant.id) { if (DEBUG) console.warn('[MeshGift] straps variant.id пустой'); return; }
    addExtra(variant.id, PROP_GIFT, gift.id);
  }

  // ─── Активация триггера скидки ──────────────────────────────
  function activateTrigger(gift) {
    cartGet().then(function (cart) {
      if (hasVariantInCart(cart, gift.triggerVariantId)) { markClaimed(); return; }
      if (hasRealItems(cart)) {
        cartAdd(gift.triggerVariantId, propObj(PROP_TRIGGER, gift.id)).then(function () {
          progress.pendingTrigger = null; markClaimed(); refreshCartUI();
        });
      } else {
        // корзина пустая — резервируем
        progress.pendingTrigger = { variantId: gift.triggerVariantId, prizeId: gift.id };
        markClaimed();
        showPending();
      }
    });
  }

  // Удалить все строки-подарки с данным свойством (для дедупликации)
  function removeGiftLines(cart, propKey) {
    var keys = (cart.items || []).filter(function (it) {
      return it.properties && it.properties[propKey];
    }).map(function (it) { return it.key; });
    var chain = Promise.resolve();
    keys.forEach(function (k) { chain = chain.then(function () { return cartChangeQty(k, 0); }); });
    return chain;
  }

  // ─── Добавление подарка (бретелі) — всегда РОВНО один ────────
  function addExtra(variantId, propKey, prizeId) {
    cartGet().then(function (cart) {
      var gifts = (cart.items || []).filter(function (it) { return it.properties && it.properties[propKey]; });
      // уже ровно этот подарок и он единственный, кол-во 1 — ничего не делаем
      if (gifts.length === 1 && gifts[0].variant_id === variantId && gifts[0].quantity === 1) {
        progress.pendingGift = null; markClaimed(); return;
      }
      if (hasRealItems(cart)) {
        // убираем любые прошлые подарки этого типа и добавляем выбранный (один)
        removeGiftLines(cart, propKey)
          .then(function () { return cartAdd(variantId, propObj(propKey, prizeId)); })
          .then(function () {
            progress.pendingGift = null; markClaimed(); refreshCartUI();
            reloadSoon();   // покажем подтверждение и обновим страницу, чтобы подарок появился
          });
      } else {
        progress.pendingGift = { variantId: variantId, prizeId: prizeId };
        markClaimed();
        showPending();
      }
    });
  }

  function propObj(key, prizeId) {
    var o = {}; o[key] = 'true'; o[PROP_PRIZE] = prizeId; return o;
  }
  function markClaimed() { progress.claimed = true; saveProgress(progress); }

  // ─── Pending мод ────────────────────────────────────────────
  function showPending() {
    var t = CFG.texts.pending;
    openOverlay({
      dismissible: true,
      build: function (m) {
        m.appendChild(el('div', 'qf-gift-prize', '🎁'));
        m.appendChild(el('h2', 'qf-gift-title', t.title));
        m.appendChild(el('p', 'qf-gift-body', t.text));
        var btn = el('a', 'qf-gift-btn', t.button);
        btn.href = CFG.collectionUrl || '/collections/all';
        m.appendChild(btn);
      }
    });
  }

  // ─── Flush pending при появлении реального товара ───────────
  // Если на момент розыгрыша корзина была пустой — подарок «резервируется»,
  // а когда появляется реальный товар, добавляем его и ПРИНУДИТЕЛЬНО перезагружаем
  // страницу, чтобы подарок сразу отобразился (как в прошлых розыгрышах).
  function flushPending() {
    if (!progress.pendingTrigger && !progress.pendingGift) return;
    cartGet().then(function (cart) {
      if (!hasRealItems(cart)) return;
      var chain = Promise.resolve();
      var didAdd = false;
      if (progress.pendingTrigger && !hasVariantInCart(cart, progress.pendingTrigger.variantId)) {
        var pt = progress.pendingTrigger;
        chain = chain.then(function () { didAdd = true; return cartAdd(pt.variantId, propObj(PROP_TRIGGER, pt.prizeId)); });
      }
      if (progress.pendingGift && !hasVariantInCart(cart, progress.pendingGift.variantId)) {
        var pg = progress.pendingGift;
        chain = chain.then(function () { didAdd = true; return cartAdd(pg.variantId, propObj(PROP_GIFT, pg.prizeId)); });
      }
      chain.then(function () {
        progress.pendingTrigger = null; progress.pendingGift = null;
        saveProgress(progress);
        if (didAdd) {
          // подарок добавлен — перезагружаем страницу, чтобы он появился
          window.location.reload();
        } else {
          refreshCartUI();
        }
      });
    });
  }

  // ─── Cart guard: блок чекаута если только подарки ───────────
  function guardCheckout() {
    var selectors = ['[name="checkout"]', 'button[name="checkout"]', 'a[href="/checkout"]', '.cart__checkout-button'];
    // вешаем перехват на кнопки чекаута после загрузки корзины
    cartGet().then(function (cart) {
      if (!cart.items || !cart.items.length) return;
      var onlyGifts = cart.items.every(isQfExtra);
      if (!onlyGifts) return;
      document.querySelectorAll(selectors.join(',')).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          showOnlyGiftsBlock();
        });
      });
    });
  }
  function showOnlyGiftsBlock() {
    var t = CFG.texts.onlyGiftsBlock;
    openOverlay({
      dismissible: true,
      build: function (m) {
        m.appendChild(el('div', 'qf-gift-prize', '🎀'));
        m.appendChild(el('h2', 'qf-gift-title', t.title));
        m.appendChild(el('p', 'qf-gift-body', t.text));
        var btn = el('a', 'qf-gift-btn', t.button);
        btn.href = CFG.collectionUrl || '/collections/all';
        m.appendChild(btn);
      }
    });
  }

  // ─── Перехват изменений корзины «на лету» ───────────────────
  // Тема добавляет/меняет товары через AJAX (без перезагрузки). Ловим это, чтобы:
  //   • досыпать отложенный подарок + перезагрузить страницу (пустая корзина на розыгрыше);
  //   • сбросить количество подарка обратно к 1 (защита от накрутки);
  //   • перезалочить строки-подарки в корзине.
  function installCartHooks() {
    var busy = false;
    function react() {
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; }, 500);
      setTimeout(function () {
        enforceGiftQuantities();
        flushPending();                              // сам перезагрузит страницу, если досыпал подарок
        if (hardenCart._apply) hardenCart._apply();
      }, 300);
    }
    function isCartWrite(u) { return /\/cart\/(add|change|update|clear)(\.js)?/i.test(u || ''); }
    function bodyIsQf(b) { b = String(b || ''); return b.indexOf('_qf_gift') > -1 || b.indexOf('_qf_trigger') > -1; }

    // fetch
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function (url, opts) {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        var ours = qfInternal > 0 || bodyIsQf(opts && opts.body);
        var pr = of.apply(this, arguments);
        if (isCartWrite(u) && !ours) { try { pr.then(function () { react(); }, function () {}); } catch (e) {} }
        return pr;
      };
    }
    // XHR (старые темы)
    try {
      var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { this.__qfUrl = u; return oo.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function (body) {
        try {
          if (isCartWrite(this.__qfUrl) && qfInternal === 0 && !bodyIsQf(body)) {
            this.addEventListener('load', function () { react(); });
          }
        } catch (e) {}
        return os.apply(this, arguments);
      };
    } catch (e) {}

    // события темы — на всякий случай
    document.addEventListener('cart:refresh', react);
    document.addEventListener('cart:updated', react);
    document.addEventListener('cart:change', react);
  }

  // ─── Cart harden: убрать ссылку на товар + блок количества у подарков ─
  function hardenCart() {
    function apply() {
      cartGet().then(function (cart) {
        var items = cart.items || [];
        var extraItems = items.filter(isQfExtra);
        if (!extraItems.length) return;
        extraItems.forEach(function (item) {
          var lines = findCartLines(item);
          // запасной способ: по индексу товара среди всех строк корзины
          if (!lines.length) {
            var idx = items.indexOf(item);
            var byIdx = cartRowByIndex(idx, items.length);
            if (byIdx) lines = [byIdx];
          }
          lines.forEach(function (line) { lockLine(line); });
        });
      });
    }
    hardenCart._apply = apply;

    apply();
    // корзина может дорисовываться асинхронно (drawer, ajax) — наблюдаем DOM
    var obs = new MutationObserver(function () {
      clearTimeout(hardenCart._tmr);
      hardenCart._tmr = setTimeout(apply, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', apply);
    document.addEventListener('cart:updated', apply);
  }

  // Что считаем «удалением» — эти элементы НЕ трогаем (юзер может убрать подарок)
  function isRemoveControl(elm) {
    var href = (elm.getAttribute && elm.getAttribute('href')) || '';
    var al = (elm.getAttribute && (elm.getAttribute('aria-label') || '')) || '';
    var cls = elm.className || '';
    var tag = (elm.tagName || '').toLowerCase();
    return tag === 'cart-remove-button' ||
      elm.closest && elm.closest('cart-remove-button') ||
      /quantity=0(\D|$)/.test(href) ||
      /remove|видал|удал|delete/i.test(al) ||
      /remove|cart-remove|removeItem|видал/i.test(cls);
  }

  // Заблокировать строку-подарок: убрать ссылку на товар + количество.
  // Удаление НЕ блокируем — гость может убрать подарок из корзины.
  function lockLine(line) {
    if (!line) return;
    line.classList.add('qf-gift-cartlock');

    // 1) количество: инпуты и кнопки +/- (но НЕ кнопку удаления)
    line.querySelectorAll('input, select, button, textarea, quantity-input, [class*="quantity"], [class*="qty"], [class*="Quantity"]').forEach(function (ctrl) {
      if (isRemoveControl(ctrl)) return;               // удаление оставляем
      var name = (ctrl.getAttribute && ctrl.getAttribute('name')) || ctrl.name || '';
      var cls  = ctrl.className || '';
      var tag  = (ctrl.tagName || '').toLowerCase();
      var isQty =
        tag === 'input' || tag === 'select' || tag === 'textarea' || tag === 'quantity-input' ||
        /updates\[|quantity|qty/i.test(name) ||
        /quantity|qty/i.test(cls) ||
        name === 'plus' || name === 'minus';
      if (isQty) {
        try { ctrl.disabled = true; } catch (e) {}
        try { ctrl.readOnly = true; } catch (e) {}
        ctrl.setAttribute && ctrl.setAttribute('tabindex', '-1');
        blockEl(ctrl);
      }
    });

    // 2) ссылки на товар-подарок — убираем переход (кроме ссылки-удаления)
    line.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (isRemoveControl(a)) return;
      a.setAttribute('aria-disabled', 'true');
      a.removeAttribute('href');
      blockEl(a);
    });
  }

  function blockEl(el) {
    if (!el || el.__qfBlocked) return;
    el.__qfBlocked = true;
    ['click', 'mousedown', 'keydown', 'change', 'input'].forEach(function (ev) {
      el.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); }, true);
    });
    el.style.pointerEvents = 'none';
  }

  // Найти ВСЕ DOM-строки корзины для данного товара-подарка (cart page + drawer)
  function findCartLines(item) {
    var variantId = item.variant_id, lineKey = item.key, handle = item.handle;
    var found = [];
    function add(node) { var l = closestLine(node); if (l && found.indexOf(l) === -1) found.push(l); }

    var sel = [
      '[data-variant-id="' + variantId + '"]',
      '[data-id="' + variantId + '"]',
      '[data-cart-item-variant-id="' + variantId + '"]',
      '[data-variant="' + variantId + '"]',
      '[data-cart-item-key="' + lineKey + '"]',
      '[data-key="' + lineKey + '"]',
      '[id*="' + lineKey + '"]'
    ];
    document.querySelectorAll(sel.join(',')).forEach(add);

    // по ссылке на товар (handle) — самый надёжный признак для скрытого подарка
    if (handle) {
      document.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(add);
    }
    // по variant= в ссылках/инпутах
    document.querySelectorAll('a[href*="variant=' + variantId + '"], input[value*="' + lineKey + '"]').forEach(add);

    return found;
  }
  function closestLine(node) {
    return node.closest('.cart-item, .cart__row, tr, li, [class*="cart-item"], [data-cart-item], [class*="line-item"], [class*="CartItem"]') || node.parentElement;
  }

  // Запасной поиск строки по индексу: собираем все строки корзины и берём idx-ю,
  // но только если их количество совпадает с числом товаров в cart.js (безопасно).
  function cartRowByIndex(idx, total) {
    if (idx < 0) return null;
    var rowSel = '.cart-item, .cart__item, .cart-items__item, cart-line-item, [data-cart-item], tr[class*="cart"], tr[class*="Cart"], li[class*="cart"], li[class*="line-item"], [class*="line-item"], [class*="CartItem"], tbody tr, ul li, ol li';
    // ищем контейнер, где ровно `total` строк
    var groups = {};
    document.querySelectorAll(rowSel).forEach(function (row) {
      var parent = row.parentElement;
      if (!parent) return;
      var key = parent;
      (groups.__list = groups.__list || []);
      var g = groups.__list.filter(function (x) { return x.parent === key; })[0];
      if (!g) { g = { parent: key, rows: [] }; groups.__list.push(g); }
      g.rows.push(row);
    });
    var list = groups.__list || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].rows.length === total && list[i].rows[idx]) return list[i].rows[idx];
    }
    return null;
  }

  // ─── Открыть текущее состояние (intro или уже выигранный подарок) ─
  function openCurrent() {
    if (progress.opened && progress.prizeId) {
      var gift = giftById(progress.prizeId);
      if (gift) { showResult(gift, null); return; }
    }
    showIntro();
  }

  // ─── Плашка-подарок в левом нижнем углу ─────────────────────
  function showFloatingBadge() {
    if (document.getElementById('qf-gift-fab')) return;
    var t = (CFG.texts && CFG.texts.floating) || {};
    var fab = el('button', 'qf-gift-fab qf-gift-root');
    fab.id = 'qf-gift-fab';
    fab.type = 'button';
    fab.setAttribute('aria-label', t.ariaLabel || 'Відкрити подарунок');

    var icon = el('span', 'qf-gift-fab__icon');
    if (CFG.assets && CFG.assets.boxClosed) {
      var img = el('img'); img.src = CFG.assets.boxClosed; img.alt = '';
      icon.appendChild(img);
    } else {
      icon.textContent = '🎁';
    }
    fab.appendChild(icon);
    if (t.label) fab.appendChild(el('span', 'qf-gift-fab__label', t.label));

    fab.addEventListener('click', openCurrent);
    document.body.appendChild(fab);
  }

  // ─── Триггер показа ─────────────────────────────────────────
  function maybeShowPopup() {
    if (!isCampaignActive) return;
    // плашка в углу — всегда (чтобы можно было відкрити потім)
    showFloatingBadge();
    // авто-показ попапа — ТОЛЬКО ОДИН РАЗ (первый заход), дальше не навязываемся
    if (progress.autoShown) return;
    setTimeout(function () {
      progress.autoShown = true;
      saveProgress(progress);
      openCurrent();
    }, CFG.showDelayMs || 5000);
  }

  // ─── Редирект со страницы товара-подарка ────────────────────
  // Если кто-то открыл страницу скрытого товара-подарка напрямую — уводим на главную,
  // чтобы нельзя было добавить бесплатные бретелі вручную.
  function redirectGiftProduct() {
    var handles = [];
    (CFG.gifts || []).forEach(function (g) { if (g.productHandle) handles.push(g.productHandle); });
    if (!handles.length) return false;
    var path = (location.pathname || '');
    for (var i = 0; i < handles.length; i++) {
      if (path.indexOf('/products/' + handles[i]) !== -1) {
        var to = CFG.giftRedirectUrl || '/';
        try { location.replace(to); } catch (e) { try { location.href = to; } catch (e2) {} }
        return true; // в любом случае прекращаем инициализацию на этой странице
      }
    }
    return false;
  }

  // ─── Init ───────────────────────────────────────────────────
  function init() {
    // редирект работает ВСЕГДА (даже вне окна акции) — бесплатный товар не должен быть доступен
    if (redirectGiftProduct()) return;

    if (isCampaignExpired) { cleanupExpired(); return; }
    if (!isCampaignActive) return; // до старта — молчим

    installCartHooks();      // перехват изменений корзины (AJAX add/change)
    enforceGiftQuantities(); // на всякий случай сбросить кол-во подарков к 1 при заходе
    flushPending();
    guardCheckout();
    hardenCart();
    maybeShowPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ─── utils ──────────────────────────────────────────────────
  function tmpl(str, data) {
    return String(str).replace(/\{(\w+)\}/g, function (_, k) { return data[k] != null ? data[k] : ''; });
  }

  // ─── Debug API (только при debug:true, чтобы юзер не мошенничал) ─
  if (DEBUG) window.MeshGift = {
    reset: function () { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} progress = defaultProgress(); console.log('[MeshGift] reset'); },
    progress: function () { return JSON.parse(JSON.stringify(progress)); },
    open: function () { showIntro(); },
    show: function (id) {
      var g = giftById(id); if (!g) { console.warn('no gift', id); return; }
      progress.opened = true; progress.prizeId = id; saveProgress(progress);
      showResult(g, null);
    },
    pick: function () { return pickGift().id; },
    simulateWeights: function (n) {
      n = n || 10000; var acc = {};
      for (var i = 0; i < n; i++) { var id = pickGift().id; acc[id] = (acc[id] || 0) + 1; }
      Object.keys(acc).forEach(function (k) { acc[k] = (acc[k] / n * 100).toFixed(1) + '%'; });
      return acc;
    },
    window: function () { return { start: CFG.campaignStart, end: CFG.campaignEnd, active: isCampaignActive, expired: isCampaignExpired }; }
  };
})();
